/* js/sideSearch.js */

jQuery(document).ready(function ($) {

if ( $( ".sideSearch" ).length ) {

    $('.widgets').addClass('widgets-hasSearch');

}

});







